import {Link, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {serverLink} from "../../resources/url";
import {toast} from "react-toastify";
import {
    EmailTemplates,
    encryptData,
    formatDateAndTime,
    projectName,
    sendEmail,
    showAlert
} from "../../resources/constants";
import {setApplicationDetails, setLoginDetails} from "../../actions/actions";
import {connect} from "react-redux";
import logo from "../../images/logo.png";
import { useParams } from "react-router-dom";

function ChangePassword(props) {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [allow, setAllow] = useState(1)
    //const token = window.location.href.split('/')[6]
    const [login, setLogin] = useState({
        Password: "",
        cPassword: "",
        EmailAddress: ""
    });
    const { token } = useParams()

    const ValidateToken = async () => {
        await axios
            .get(`${serverLink}application/forget_password/validate_token/${token}`)
            .then((res) => {
                if (res.data.length === 0) {
                    setAllow(0)
                    showAlert("Error", "The link has expired, kindly send another email to reset your password", "error").then(() => {
                        navigate('/login')
                    })
                } else {
                    setLogin({
                        ...login,
                        EmailAddress: res.data[0].EmailAddress
                    })
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log("NETWORK ERROR", err);
            });
    };

    useEffect(() => {
        ValidateToken();
    }, []);


    const handleReset = async (e) => {
        e.preventDefault();
        if (login.Password !== login.cPassword) {
            toast.error('Password does not match');
            return;
        }

        const formData = {
            Password: encryptData(login.Password),
            EmailAddress: login.EmailAddress
        }

        if (allow === 1) {
            await axios.patch(`${serverLink}application/forget_password/change_password/${token}`, formData)
                .then((result) => {
                    if (result.data.message === "success") {
                        toast.success('Your password have been changed successfully.');
                        navigate('/login')
                    } else {
                        toast.error('Please try again.')
                    }
                }).catch((e) => {
                    toast.error('Please try again.')
                    console.log('NETWORK ERROR')
                })
        }

    }

    const onEdit = (e) => {
        setLogin({
            ...login,
            [e.target.id]: e.target.value
        })
    };

    return (
        <>
            {/* Main Wrapper */}
            <div className="main-wrapper">
                <div className="container-fuild">
                    <div className="login-wrapper w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
                        <div className="row" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', maxHeight: '85vh' }}>

                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
                                    <div className="col-md-8 mx-auto p-4">
                                        <form onSubmit={handleReset}>
                                            <div>
                                                <div className=" mx-auto mb-5 text-center">
                                                    <img
                                                        src={logo}
                                                        className="img-fluid"
                                                        alt="Logo"
                                                        width={100}
                                                    />
                                                </div>
                                                <div className="card">
                                                    <div className="card-body p-4">
                                                        <div className=" mb-4">
                                                            <h2 className="mb-2">Change Password</h2>
                                                            <p className="mb-0">
                                                                Please enter your email address to reset password
                                                            </p>
                                                        </div>
                                                        <div className="login-or">
                                                            <span className="span-or">Or</span>
                                                        </div>
                                                        <div className="mb-3 ">
                                                            <label className="form-label">New Password</label>
                                                            <div className="input-icon mb-3 position-relative">
                                                                <span className="ti toggle-password ti-eye-off" />
                                                                <input
                                                                    type="password"
                                                                    id="Password"
                                                                    className="form-control pass-input"
                                                                    placeholder="Password*"
                                                                    onChange={onEdit}
                                                                />
                                                            </div>

                                                        </div>
                                                        <div className="mb-3 ">
                                                            <label className="form-label">Confirm Password</label>
                                                            <div className="input-icon mb-3 position-relative">
                                                                <span className="ti toggle-password ti-eye-off" />
                                                                <input
                                                                    type="password"
                                                                    id="cPassword"
                                                                    className="form-control pass-input"
                                                                    placeholder="Confirm Password*"
                                                                    onChange={onEdit}
                                                                />
                                                            </div>

                                                        </div>
                                                        <div className="mb-3">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary w-100"
                                                            >
                                                                Reset Password
                                                            </button>
                                                        </div>
                                                        <div className="text-center">
                                                            <h6 className="fw-normal text-dark mb-0">
                                                                Don’t have an account?{" "}
                                                                <Link to="/register" style={{color:"#007bff"}}>
                                                                    Register here
                                                                </Link>
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mt-5 text-center">
                                                    <p className="mb-0 ">Copyright © {formatDateAndTime(new Date(), 'year_only')} {projectName} All Rights Reserved</p>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnApplicationDetails: (p) => {
            dispatch(setApplicationDetails(p));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
